import { render, staticRenderFns } from "./orderInfo.vue?vue&type=template&id=7ccac2d1&"
import script from "./orderInfo.vue?vue&type=script&lang=ts&"
export * from "./orderInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports